export type AvailablePageTemplates = {
  documentType: string;
};

export const PageTemplates: AvailablePageTemplates[] = [
  { documentType: "pageAiFeatures" },
  { documentType: "pagePricing" },
  {
    documentType: "pageHome",
  },
];
